const data = {
	"hFlip": true,
	"width": 576,
	"height": 1280,
	"body": "<path fill=\"currentColor\" d=\"M576 192v896q0 26-19 45t-45 19t-45-19L19 685Q0 666 0 640t19-45l448-448q19-19 45-19t45 19t19 45z\"/>"
};
export default data;
